import { ResultCard, type SearchResultCardData } from '@entities/search-run';

import { useFavoriteToggle } from '../model/useFavoriteToggle';
import { vehicleLabel } from '../model/vehicleLabel';

import { FavoriteNotice } from './FavoriteNotice';
import { FavoriteToggle } from './Favorites';

interface PaidResultCardProps {
  searchId: string;
  runId: string;
  item: SearchResultCardData;
  to: string;
  index?: number | undefined;
}

/**
 * Полная карточка оплаченного заказа с сердечком (FE-586, «после оплаты»).
 *
 * Список после оплаты прежний — балл, причины, сигналы (FE-081), — и отметки
 * избранного в нём те же, что до оплаты: закладка живёт на заказе (BE-581).
 */
export function PaidResultCard({ searchId, runId, item, to, index = 0 }: PaidResultCardProps) {
  const { toggle, failed, pending } = useFavoriteToggle({
    searchId,
    runId,
    vehicleId: item.vehicle_id,
  });
  const label = vehicleLabel(item);

  return (
    <ResultCard
      result={item}
      index={index}
      to={to}
      favorite={
        <FavoriteToggle
          pressed={item.is_favorite}
          onToggle={toggle}
          vehicleLabel={label}
          busy={pending}
        />
      }
      notice={failed ? <FavoriteNotice failed={failed} name={label} /> : null}
    />
  );
}
